import { render, staticRenderFns } from "./price-list.vue?vue&type=template&id=0f2cf994&scoped=true"
import script from "./price-list.vue?vue&type=script&lang=js"
export * from "./price-list.vue?vue&type=script&lang=js"
import style0 from "./price-list.vue?vue&type=style&index=0&id=0f2cf994&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f2cf994",
  null
  
)

export default component.exports